import { path } from "ramda";

export const mainClientTypeSelector = path([
  "getScoreCardsByType",
  "clientTypes",
]);



// WEBPACK FOOTER //
// ./src/selectors/getScoreCardByTypeSelectors.js